import { ProductFilters } from '../../types/models/product/product'

export const transformProductFiltersToUrl = (filters?: ProductFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.years && filters.years.length) searchParams.append('years', filters.years.join(','))
  if (filters.options && filters.options.length)
    searchParams.append('options', filters.options.join(','))
  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))
  if (filters.tripIds && filters.tripIds.length)
    searchParams.append('tripIds', filters.tripIds.join(','))
  if (filters.journeyPlaces && filters.journeyPlaces.length)
    searchParams.append('journeyPlaces', filters.journeyPlaces.join(','))
  if (filters.durationInDays)
    searchParams.append('durationInDays', filters.durationInDays.toString())
  if (filters.mainOptions && filters.mainOptions.length)
    searchParams.append('mainOptions', filters.mainOptions.join(','))
  if (filters.countryId) searchParams.append('countryId', filters.countryId.toString())
  if (filters.formulaId) searchParams.append('formulaId', filters.formulaId.toString())
  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))
  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))

  return searchParams.toString()
}

export const transformUrlToProductFilters = (searchParams: URLSearchParams): ProductFilters => {
  const filters: ProductFilters = {}

  const years = searchParams.get('years')
  if (years && years.length) filters.years = years.split(',').map(Number)

  const options = searchParams.get('options')
  if (options && options.length) filters.options = options.split(',')

  const mainOptions = searchParams.get('mainOptions')
  if (mainOptions && mainOptions.length) filters.mainOptions = mainOptions.split(',')

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',')

  const tripIds = searchParams.get('tripIds')
  if (tripIds && tripIds.length) filters.tripIds = tripIds.split(',').map(Number)

  const journeyPlaces = searchParams.get('journeyPlaces')
  if (journeyPlaces && journeyPlaces.length) filters.journeyPlaces = journeyPlaces.split(',')

  const durationInDays = searchParams.get('durationInDays')
  if (durationInDays) filters.durationInDays = durationInDays.split(',').map(Number)

  const countries = searchParams.get('countries')
  if (countries && countries.length) filters.countries = countries.split(',').map(String)

  const formulas = searchParams.get('formulas')
  if (formulas && formulas.length) filters.formulas = formulas.split(',').map(String)

  const countryId = searchParams.get('countryId')
  if (countryId) filters.countryId = +countryId

  const formulaId = searchParams.get('formulaId')
  if (formulaId) filters.formulaId = +formulaId

  return filters
}
